export const LogicalOperation = Object.freeze({
    AND: 'AND',
    OR: 'OR',
    NOT: 'NOT',
});

export const LinkType = Object.freeze({
    CONNECTOR: 'connector',
    PROCEDURE: 'procedure',
    ATTRIBUTE: 'attribute',
});

export const Operator = Object.freeze({
    EQ: '==',
    LT: '<',
    GT: '>',
    LTE: '<=',
    GTE: '>=',
    NTE: '!=',
});

export const Procedure = Object.freeze({
    USER_TODAY_AGE: 'user_today_age',
    ASSESSMENT_DATE: 'assessment_date',
    ASSESSMENT_USER_AGE: 'assessment_user_age',
    ASSESSMENT_CODE: 'assessment_code',
    ATTRIBUTE: 'attribute',
    FIRST_ATTRIBUTE: 'first_attribute',
    LAST_ATTRIBUTE: 'last_attribute',
    PASS_FAIL: 'pass_fail',
    USER_PROFILE: 'user_profile',
    USER_LIST: 'user_list',
    ACTIVE_ONLY_ASSESSMENT: 'active_only_assessment',
    ACTIVE_ONLY_ATTRIBUTE: 'active_only_attribute',
    WITHOUT_ASSESSMENT_CODE: 'without_assessment_code',
});
